import React from "react";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { GATEWAY_PROXY } from "utils/apiUtils";

export function MFEContainer({ children, className, account, user, brand, usage, ...props }) {
	if (account) {
		account.usage = usage?.fullReport || {};
	}

	const childrenWithProps = React.Children.map(children, (child) =>
		React.isValidElement(child) ? React.cloneElement(child, { ...props, account, user, brandObj: brand, proxyUrl: GATEWAY_PROXY }) : child
	);

	return <div className={`${className} MFEContainer`}>
		{childrenWithProps}
	</div>;
}

MFEContainer.propTypes = {
	user: PropTypes.object,
	account: PropTypes.object,
	brand: PropTypes.object,
	usage: PropTypes.object,
	children: PropTypes.node,
	className: PropTypes.string,
};

export default withRouter(
	connect(
		(state) => {
			return {
				account: state.global.account,
				user: state.global.user,
				brand: state.brand,
				usage: state.global.usage,
			};
		},
		null
	)(MFEContainer)
);
